module.exports = __webpack_public_path__ + "img/wein-wellness-mobil.9458025a.jpg";